/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
// material
import { Form, Grid, GridSet, GridItem, TextField } from '@insticator/insticator-ui'; // iui-material

//styles
import styles from './paypal_styles';
import injectSheet from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPaypalInformation } from '../../../../../../../state/thunks/account';
import { validation } from '../../../../../../../utils/validation';


const formName = 'PAYPAL'

/* ========== ~~~~~~~~~~ PAYPAL  ~~~~~~~~~~ ========== */
const Paypal = injectSheet(styles)((props) => {
    const dispatch = useDispatch()

    const { paypalUUID, details, setDetails, onFormChange, editable, isSaveClicked } = props
    const { payments } = useSelector(state => state.account)

    useEffect(() => {
      if(paypalUUID) dispatch(fetchPaypalInformation(paypalUUID))
    },[paypalUUID, dispatch])

    useEffect(() => {
      if(payments.paypal && paypalUUID) setDetails(payments.paypal)
    }, [payments, paypalUUID, setDetails])

    const isValid = name => !paypalUUID ? (!isSaveClicked || validation[name].test.test(details[name])) : !editable || validation[name].test.test(details[name])

    return(
      <Form formName={formName}>
        <Grid  klass={`paypal ${props.classes.paypal}`}>
            <GridSet align={`horizontal`} >
                <GridItem type={`full`}>
                  <TextField 
                    type={`text`} 
                    name={`paypalUserName`} 
                    value={details.paypalUserName} 
                    valid={isValid('paypalUserName')}
                    handleChange={e => onFormChange('paypalUserName', e.target.value)} 
                    formName={formName} 
                    placeholder={`PayPal username`} 
                    label={`PayPal Username`} 
                    info={``} 
                    required 
                    disabled={!editable}
                  />
                </GridItem>
            </GridSet>
        </Grid>
      </Form>
    );

});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Paypal